// The site's own tooltip (2026-10-23), in the refresh's navy and brass: `v-tip` in place of the browser's plain
// `title`. One floating box serves the whole page.
//
//   v-tip="'Plain text'"
//   v-tip="{ kicker, title, color (a team color for the box's left edge), sub, rows: [[label, value, color?, grade?]],
//             pairs: [[name, value]], groups: [{ label, chips }], chips: [{ text, color?, grade? }], lines: [text], foot }"
//   a row's value can also be a list of segments [{ text, color? }], shown ' · '-joined, each in its own color
//   grade = { text, color }: a grade as the site's filled pill (a tier color as text on navy is unreadable)
//   v-tip="() => ({ … })"   a function is called when the tip opens, so costly content is only built for what's hovered
//
// Hover or keyboard focus opens it after a moment; leaving, clicking, scrolling or Escape closes it. A touch never
// opens it, since a tap already does the element's own job. Everything is set as text, never as HTML, because the
// content carries player names from the API.

let box = null;       // the floating element
let owner = null;     // the element it's showing for
let timer = 0;

function el(tag, cls, text) {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text != null && text !== '') e.textContent = String(text);
  return e;
}

function gradePill(g) {
  const p = el('i', 'lx-grade lx-tip-grade', g.text);
  if (g.color) p.style.background = g.color;
  return p;
}

function render(v) {
  if (typeof v === 'function') v = v();
  if (v == null || v === '' || v === false) return null;
  const root = el('div', 'lx-tip-in');
  if (v && typeof v === 'object' && v.color) root._color = v.color;   // a team's color edges the box (as text, dark teams wouldn't read)
  if (typeof v !== 'object') { root.appendChild(el('div', 'lx-tip-text', v)); return root; }
  if (v.kicker) root.appendChild(el('div', 'lx-tip-kicker', v.kicker));
  if (v.title) root.appendChild(el('div', 'lx-tip-title', v.title));
  if (v.sub) root.appendChild(el('div', 'lx-tip-sub', v.sub));
  if (v.rows && v.rows.length) {
    const g = el('div', 'lx-tip-rows');
    for (const [k, val, color, grade] of v.rows) {
      if (val == null || val === '' || (Array.isArray(val) && !val.length)) continue;
      g.appendChild(el('span', 'lx-tip-k', k));
      const d = el('span', 'lx-tip-v');
      if (grade) d.appendChild(gradePill(grade));
      if (Array.isArray(val)) {
        val.forEach((sg, i) => {
          if (i) d.appendChild(document.createTextNode(' · '));
          const sp = el('span', null, sg.text);
          if (sg.color) sp.style.color = sg.color;
          d.appendChild(sp);
        });
      } else d.appendChild(document.createTextNode(val));
      if (color) d.style.color = color;
      g.appendChild(d);
    }
    root.appendChild(g);
  }
  if (v.pairs && v.pairs.length) {   // name → value, two to a row (a unit's abilities and their output)
    const g = el('div', 'lx-tip-pairs');
    for (const [k, val] of v.pairs) { const s = el('span', 'lx-tip-pair', k); if (val) s.appendChild(el('b', null, val)); g.appendChild(s); }
    root.appendChild(g);
  }
  for (const grp of v.groups || []) {   // a labelled chip row (zodiac vs a team)
    if (!grp.chips || !grp.chips.length) continue;
    const c = el('div', 'lx-tip-chips');
    c.appendChild(el('span', 'lx-tip-k', grp.label));
    for (const ch of grp.chips) { const s = el('span', 'lx-tip-chip', ch.text); if (ch.color) s.style.borderColor = s.style.color = ch.color; c.appendChild(s); }
    root.appendChild(c);
  }
  if (v.chips && v.chips.length) {
    const c = el('div', 'lx-tip-chips');
    for (const ch of v.chips) {
      const s = el('span', 'lx-tip-chip', typeof ch === 'string' ? ch : ch.text);
      if (ch.color) s.style.borderColor = s.style.color = ch.color;
      if (ch.grade) s.appendChild(gradePill(ch.grade));
      c.appendChild(s);
    }
    root.appendChild(c);
  }
  for (const line of v.lines || []) if (line) root.appendChild(el('div', 'lx-tip-line', line));
  if (v.foot) root.appendChild(el('div', 'lx-tip-foot', v.foot));
  return root;
}

function place(target) {
  const r = target.getBoundingClientRect();
  const w = box.offsetWidth, h = box.offsetHeight, gap = 8, pad = 8;
  const vw = document.documentElement.clientWidth, vh = window.innerHeight;
  let top = r.top - h - gap;
  let below = false;
  if (top < pad) { top = r.bottom + gap; below = true; }
  if (below && top + h > vh - pad) top = Math.max(pad, vh - h - pad);
  const left = Math.min(Math.max(pad, r.left + r.width / 2 - w / 2), vw - w - pad);
  box.style.transform = `translate(${Math.round(left)}px, ${Math.round(top)}px)`;
  box.classList.toggle('below', below);
}

function show(target) {
  const content = render(target._tip);
  if (!content) return hide();
  if (!box) {
    box = el('div', 'lx-tip');
    box.id = 'lx-tip';
    box.setAttribute('role', 'tooltip');
    document.body.appendChild(box);
  }
  box.replaceChildren(content);
  box.style.borderLeftColor = (content._color) || '';
  box.classList.add('on');
  owner = target;
  target.setAttribute('aria-describedby', 'lx-tip');
  place(target);
}

function hide() {
  clearTimeout(timer);
  if (owner) owner.removeAttribute('aria-describedby');
  owner = null;
  if (box) box.classList.remove('on');
}

function enter(e) {
  if (e.pointerType === 'touch') return;
  const t = e.currentTarget;
  clearTimeout(timer);
  timer = setTimeout(() => show(t), owner ? 0 : 140);   // already showing one: switch at once
}
function focusIn(e) { if (e.currentTarget.matches(':focus-visible')) { clearTimeout(timer); show(e.currentTarget); } }

let wired = false;
function wireGlobal() {
  if (wired) return;
  wired = true;
  window.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);
  window.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });
}

export const tip = {
  mounted(target, binding) {
    wireGlobal();
    target._tip = binding.value;
    target.addEventListener('pointerenter', enter);
    target.addEventListener('pointerleave', hide);
    target.addEventListener('pointerdown', hide);
    target.addEventListener('focus', focusIn);
    target.addEventListener('blur', hide);
  },
  updated(target, binding) {
    target._tip = binding.value;
    if (owner === target && typeof binding.value !== 'function') show(target);
  },
  beforeUnmount(target) {
    if (owner === target) hide();
    target.removeEventListener('pointerenter', enter);
    target.removeEventListener('pointerleave', hide);
    target.removeEventListener('pointerdown', hide);
    target.removeEventListener('focus', focusIn);
    target.removeEventListener('blur', hide);
  },
};
